import JuristicFeatureLayout from "./JuristicFeatureLayout";
import JuristicFeatureProjectListPage from "./pages/JuristicFeatureProjectListPage";
import JuristicFeatureProjectEditor from "./pages/JuristicFeatureProjectEditor";

export const juristicFeatureRoutes = {
  path: "juristic-feature",
  component: JuristicFeatureLayout,
  children: [
    {
      name: "JuristicFeatureListPage",
      component: JuristicFeatureProjectListPage,
      path: ""
    },
    {
      name: "JuristicFeatureProjectEditor",
      path: ":id",
      component: JuristicFeatureProjectEditor
    }
  ]
};
